module.exports = __webpack_public_path__ + "static/media/publish.29bb3214.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/publish.png
// module id = 302
// module chunks = 0